import Table from "components/Table";
import React, { useMemo } from "react";
import { reportsColumns } from "./columns";

const data = [];

const AllReports = () => {
  const columns = useMemo(() => {
    return reportsColumns();
  }, []);
  return (
    <Table
      headers={columns}
      data={data}
      containerStyle={{
        borderRadius: "0px",
        border: "none",
      }}
    />
  );
};

export default AllReports;
